import { IGNITE_ENVIRONMENTS } from '@/constants/environment';
import type { IGNITE_ENVIRONMENTS as IGNITE_ENVIRONMENTS_ENUM } from '@/types';

export function isProductionEnvironment(): boolean {
  if (process.env.NODE_ENV === 'development') {
    return false;
  }
  const productionEnvs: IGNITE_ENVIRONMENTS_ENUM[] = [
    IGNITE_ENVIRONMENTS.PRODUCTION,
    IGNITE_ENVIRONMENTS.PRODUCTION_CA,
    IGNITE_ENVIRONMENTS.PRODUCTION_EU,
  ];

  return productionEnvs.includes(import.meta.env.VITE_SENTRY_ENV);
}

export function isStagingEnvironment(): boolean {
  if (process.env.NODE_ENV === 'development') {
    return false;
  }
  const stagingEnvs: IGNITE_ENVIRONMENTS_ENUM[] = [IGNITE_ENVIRONMENTS.QA_STAGE6, IGNITE_ENVIRONMENTS.QA_STAGE8];

  return stagingEnvs.includes(import.meta.env.VITE_SENTRY_ENV);
}

export function isProductionOrPreProduction(): boolean {
  return isProductionEnvironment() || isStagingEnvironment();
}

export function getWalkMeEnvironment(): 'production' | 'test' {
  return isProductionOrPreProduction() ? 'production' : 'test';
}
